<div id="license_validation">
  <h4 *ngIf="showTitle">Your {{ stateLabel }} Real Estate License</h4>
  <form (ngSubmit)="validateLicense()">
    <tgf-form-control-question-processor
      [parentModel]="this.actualModel"
      [form]="questionForm" [questionJson]="questionJson">
    </tgf-form-control-question-processor>
    <button
      *ngIf="licenseValidatedName && !variablesService.getVariable(licenseValidatedName)"
      class="sd-btn sd-btn--action"
      [disabled]="isItLoading()">
      Validate License
    </button>
    <ng-container *ngIf="licenseValidatedName && !!variablesService.getVariable(licenseValidatedName)">
      <div style="white-space: normal;">
        <button
          type="button"
          (click)="validateAgain()"
          class="sd-btn sd-btn--action me-2"
          [disabled]="isItLoading()">
          Validate again
        </button>
        <span class="success-message">
          <i class="color-success fa-solid fa-circle-check me-2"></i>Your License is valid. Is this not you?
        </span>
      </div>
    </ng-container>
  </form>
</div>
<tg-spinner [blockAll]="true" *ngIf="isItLoading()"></tg-spinner>
